<template>
  <div class="loading">
    <div class="icon icon-loading"></div>
  </div>
</template>

<script>
export default {
name: "LoadingAnimation"
}
</script>